export default __webpack_public_path__ + "static/pragicts-ai-banner-insights-c3963bd7d2d566225eaa72e18226123a.jpg";